import React, { Component } from "react";
import axios from "axios";

// Redux
import store from "./store";
import { Provider } from "react-redux";

// Redux Action
import { loadUser } from "./action/authActions";

// Pages
import Home from "./pages/Home";

// Style(scss)
// import "./assets/styles/style.scss";

// Assets
import "./assets/css/style.css";
import "./assets/css/animate.css";
import "./assets/css/all.min.css";
import "./assets/css/fonts.css";
import "./assets/css/bootstrap.min.css";

export default class App extends Component {
  // componentWillMount() {
  //   store.dispatch(loadUser());
  // }

  render() {
    return (
      <Provider store={store}>
        <Home />
      </Provider>
    );
  }
}
